import QuestionDTO from "@/app/exercise/components/question/core/DTO/questionDTO";
import { moveArrayElem } from '@/util';
import {AUTO_EXAM_TYPES, NON_AUTO_EXAM_TYPES} from "../exam-const";

export default class ExamModel {
  constructor(item = {}) {
    this.id = item.id;
    this.name = item.name;
    this.order = item.order;
    this.publicVisible = item.public_visible;
    this.isDemo = item.is_demo;
    this.description = item.description;
    this.thumbnail = item.thumbnail;
    // to be removed hazardQuestions, knowledgeQuestions, insightQuestions
    this.hazardQuestions = item.hazard_questions ? item.hazard_questions.map(question => new QuestionDTO(question)) : [];
    this.knowledgeQuestions = item.knowledge_questions ? item.knowledge_questions.map(question => new QuestionDTO(question)) : [];
    this.insightQuestions = item.insight_questions ? item.insight_questions.map(question => new QuestionDTO(question)) : [];
    this.nonAutoQuestions = item.non_auto_questions ? item.non_auto_questions.map(question => new QuestionDTO(question)) : [];
    this.autoQuestions = item.auto_questions ? item.auto_questions.map(question => new QuestionDTO(question)) : [];
    this.is_auto = item.is_auto || false;
    this.is_motor = item.is_motor || false;
    this.is_scooter = item.is_scooter || false;
    this.is_wiki = item.is_wiki || false;
    this.is_les = item.is_les || false;
    this.is_online = item.is_online || false;

    this._apiAttributes = {
      name: 'name',
      order: 'order'
    };
  }

  get canMakePublicVisible() {
    if(this.is_auto) {
      return this.autoQuestions.length === AUTO_EXAM_TYPES.autoQuestions.maxLength;
    } else {
      return this.nonAutoQuestions.length === NON_AUTO_EXAM_TYPES.nonAutoQuestions.maxLength;
    }
  }

  get licenseTypes() {
    const licenseTypes = [];
    if (this.is_auto) {
      licenseTypes.push('auto');
    }
    if(this.is_motor) {
      licenseTypes.push('motor');
    }
    if(this.is_scooter) {
      licenseTypes.push('scooter');
    }
    return licenseTypes.join(', ');
  }

  addItem(item, examType, index = null) {
    const isNonAutoType = examType === 'nonAutoQuestions';
    const isDuplicate = (isNonAutoType ? [...this.nonAutoQuestions] : [
      ...this.autoQuestions
    ]).find(question => question.id === item.id);
    if (!isDuplicate) {
      if( index !== null ) {
        this[examType].splice(index, 0, item);
      } else {
        this[examType].push(item);
      }
      return;
    }
    return Boolean(isDuplicate);
  }

  removeItem(item, examType) {
    if (Array.isArray(item)) {
      this[examType] = this[examType].filter(question => {
        const isDeletedItemInQuestions = item.find(_item => question.id === _item.id);
        return !isDeletedItemInQuestions;
      });
    } else {
      this[examType] = this[examType].filter(question => question.id !== item.id)
    }
  }

  moveItem(direction, index, examType) {
    if (!(index === 0 && direction === 'up')) {
      const moveItemToIndex = direction === 'up' ? index - 1 : index + 1;
      moveArrayElem(this[examType], index, moveItemToIndex);
    }
  }

  isValid() {
    let valid = true,
      requiredFields = [
        this.name,
      ]
    requiredFields.forEach(field => {
      if(!field) valid = false
    })
    return valid
  }

  validate (validator) {
    validator.resetFields()
    this.validateLicenseTypes(validator)
    return validator.isValid()
  }

  validateLicenseTypes(validator) {
    if (!this.is_auto && !this.is_motor && !this.is_scooter) {
      validator.invalidField('licenseTypes', 'License type should be selected');
    }
  }

  getApiData() {
    return {
      name: this.name,
      description: this.description,
      public_visible: this.publicVisible,
      is_demo: this.isDemo,
      hazard_questions: this.hazardQuestions.map(question => question.id),
      knowledge_questions: this.knowledgeQuestions.map(question => question.id),
      insight_questions: this.insightQuestions.map(question => question.id),
      non_auto_questions: this.nonAutoQuestions.map(question => question.id),
      auto_questions: this.autoQuestions.map(question => question.id),
      order: this.order,
      thumbnail: this.thumbnail,
      is_auto: this.is_auto || false,
      is_motor: this.is_motor || false,
      is_scooter: this.is_scooter || false,
      is_wiki: this.is_wiki || false,
      is_les: this.is_les || false,
      is_online: this.is_online || false,
    }
  }
}